import { Component } from '@angular/core';
import { MainPage, NavController, ErrorResult, ToastController, LocalStorageService, App, ViewController, AlertController, UserService } from '../mainpage';
import { NewTicketPage } from '../newticket/newticket';
import { AboutPage } from '../about/about';
import { BetPage } from '../contest/bet';
import { GamePage } from '../contest/game';
import { StatmentPage } from '../contest/statment';
import { RankPage } from '../contest/rank';
import { TicketGroupPage } from '../contest/ticketgroup2';
import { ContestService } from '../../providers/contest';
import { PaymentPage } from '../about/payment';
import { WhatsAppPage } from '../about/whatsapp';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage extends MainPage{
  
  constructor(public navCtrl: NavController, public toastController: ToastController, 
    public localStorage: LocalStorageService, public contestService: ContestService, public viewCtrl: ViewController,
    public appCtrl: App, protected alertController: AlertController, protected userService: UserService) {
    super(navCtrl, toastController, localStorage, alertController, userService, appCtrl);
      this.loadPage();
  }

  loadPage(): void {
  }

  newTicket(): void {
    this.go(NewTicketPage);
  }

  bet(): void {
    this.go(BetPage);
  }

  whatsApp(): void {
    this.go(WhatsAppPage);
  }

  payment(): void {
    this.go(PaymentPage);
  }

  about(): void {
    this.go(AboutPage);
  }

  statment(): void {
    this.go(StatmentPage);
  }

  rank(): void {
    this.go(RankPage);
  }

  ticketGroup(): void {
    this.go(TicketGroupPage);
  }

  game(): void {
    this.go(GamePage);
  }

  

  prepareAudith(): void {
    this.contestService.prepareAudith().then((data: string) => {
        this.prepareAudithSuccess(data);
    }).catch((err) => {
        this.getError(<ErrorResult>err);
      }); 
  }

  prepareAudithSuccess(path: string): void {
    document.getElementById("audithSpan").innerHTML = "<iframe src='" + this.baseUrl + path + "' id='audith_anchor'></iframe>";
  }

  getBalance(): void {
    document.getElementById("audithSpan").innerHTML = "<a href='" + this.baseUrl + "docs/Prestacao de contas Copa.pdf' id='rules_anchor' download='Prestacao de contas Copa.pdf' target='_blank'></a>";
    document.getElementById("rules_anchor").click();
  }

  getRules(): void {
    document.getElementById("audithSpan").innerHTML = "<a href='" + this.baseUrl + "docs/Regulamento BOLÃOdaGERALCOPA.pdf' id='rules_anchor' download='Regulamento BOLÃOdaGERALCOPA.pdf' target='_blank'></a>";
    document.getElementById("rules_anchor").click();
  }

  getPointsInfo(): void {
    document.getElementById("audithSpan").innerHTML = "<a href='" + this.baseUrl + "docs/PontuaçãoCopa.pdf' id='rules_anchor' download='PontuaçãoCopa.pdf' target='_blank'></a>";
    document.getElementById("rules_anchor").click();
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts